import { DialogComponent } from '@theme/dialog';

/* sis-info-lightbox: opens a merchant-picked Shopify page's content in a
   DS-styled modal (Photo Guide, Size Guide, INFO tooltips). All behavior
   comes from Horizon's DialogComponent (declarative on:click="/showDialog"
   and "/closeDialog", scroll-lock, esc/backdrop close). */
class SisInfoLightbox extends DialogComponent {}

if (!customElements.get('sis-info-lightbox')) {
  customElements.define('sis-info-lightbox', SisInfoLightbox);
}
